let sentryConfig = null
const sentryConfigElement = document.getElementById('sentryConfig')
if (sentryConfigElement) {
    sentryConfig = JSON.parse(sentryConfigElement.textContent)
}

export default sentryConfig